import { TranslationKeys } from '~/common/types';

export const CIVILITY = {
  MR: 'MR',
  MRS: 'MRS',
} as const;

export const CIVILITY_LABEL: Record<string, keyof TranslationKeys> = {
  [CIVILITY.MR]: 'app.purchase.quote_cart_page.contact.civility.mr',
  [CIVILITY.MRS]: 'app.purchase.quote_cart_page.contact.civility.mrs',
};
